import React from 'react';
import CampaignsTable from "components/Campaign/CampaignsTable";

const Campaigns = () => {
    return (
        <CampaignsTable />
    );
}

export default Campaigns;
